import styled from "styled-components";

export const StyledCheckbox = styled.input`
    cursor: pointer;
    margin-right: 7px;
`